import { render, staticRenderFns } from "./CurveChart.vue?vue&type=template&id=542b5d7d"
import script from "./CurveChart.vue?vue&type=script&lang=js"
export * from "./CurveChart.vue?vue&type=script&lang=js"
import style0 from "./CurveChart.vue?vue&type=style&index=0&id=542b5d7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports